import React from 'react'
import Layout from "../components/layout"
import SEO from "../components/seo"
import CabinsFullWidth from "../components/cabinsFullWidth"
import Shipwreck from "../components/shipwreck"
import ContactInfo from "../components/contactInfo"

const ShipwreckCabin = () => {
  return (
    <Layout>
      <SEO
        title="Shipwreck Cabin"
        description="The Shipwreck Studio Cabin at Gold Coast Retreat — a cozy vacation rental steps from Chesterman Beach in Tofino, BC."
      />
      <Shipwreck />
      <ContactInfo />
      <CabinsFullWidth/>
    </Layout>
  )
}

export default ShipwreckCabin
